export const AREA_CODES = [
  {
    name: "United States & Canada",
    dial_code: "+1",
    flag: "🇺🇸🇨🇦",
    country_code: "US",
  },
  {
    name: "France",
    dial_code: "+33",
    flag: "🇫🇷",
    country_code: "FR",
  },
  {
    name: "Croatia",
    dial_code: "+385",
    flag: "🇭🇷",
    country_code: "HR",
  },
  {
    name: "Switzerland",
    dial_code: "+41",
    flag: "🇨🇭",
    country_code: "CH",
  },
  {
    name: "Austria",
    dial_code: "+43",
    flag: "🇦🇹",
    country_code: "AT",
  },
  {
    name: "United Kingdom",
    dial_code: "+44",
    flag: "🇬🇧",
    country_code: "GB",
  },
  {
    name: "Sweden",
    dial_code: "+46",
    flag: "🇸🇪",
    country_code: "SE",
  },
  {
    name: "Norway",
    dial_code: "+47",
    flag: "🇳🇴",
    country_code: "NO",
  },
  {
    name: "Germany",
    dial_code: "+49",
    flag: "🇩🇪",
    country_code: "DE",
  },
  {
    name: "Brazil",
    dial_code: "+55",
    flag: "🇧🇷",
    country_code: "BR",
  },
  {
    name: "Australia",
    dial_code: "+61",
    flag: "🇦🇺",
    country_code: "AU",
  },
  {
    name: "New Zealand",
    dial_code: "+64",
    flag: "🇳🇿",
    country_code: "NZ",
  },
  {
    name: "Singapore",
    dial_code: "+65",
    flag: "🇸🇬",
    country_code: "SG",
  },
  {
    name: "Japan",
    dial_code: "+81",
    flag: "🇯🇵",
    country_code: "JP",
  },
  {
    name: "South Korea",
    dial_code: "+82",
    flag: "🇰🇷",
    country_code: "KR",
  },
  {
    name: "Hong Kong",
    dial_code: "+852",
    flag: "🇭🇰",
    country_code: "HK",
  },
  {
    name: "China",
    dial_code: "+86",
    flag: "🇨🇳",
    country_code: "CN",
  },
  {
    name: "India",
    dial_code: "+91",
    flag: "🇮🇳",
    country_code: "IN",
  },
];